import Button from '@/common/components/base/button/Button';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import MainLayout from '@/common/components/layouts/MainLayout';
import { useState } from 'react';
import { Box } from 'styled-system/jsx';
import AddSvg from '@/common/assets/icons/add.svg?react';
import { token } from 'styled-system/tokens';
import WagesList from '@/modules/adjusterReportModules/IncidentParticipants/components/expert/WagesList';
import WagesModal from '@/modules/adjusterReportModules/IncidentParticipants/components/modals/WagesModal';
import { getWagesListQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getWagesList/getWagesListQueryOption';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

export default ({ isEditable = true }: { isEditable?: boolean }) => {
  return (
    <MainLayout title="زیان‌دیده / کارشناسی" header="titleHeader">
      <WagesPage isEditable={isEditable} />
    </MainLayout>
  );
};

const WagesPage = ({ isEditable = true }: { isEditable?: boolean }) => {
  const { id, damagedId } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const { refetch: refetchWagesList } = useQuery(
    getWagesListQueryOptions({ id: +id!, damaged_id: +damagedId! }),
  );
  return (
    <Box pt={24}>
      <WagesModal
        open={openModal}
        setOpenModal={() => {
          refetchWagesList();
          setOpenModal(false);
        }}
      />
      <TitleDescription>اجرت تعمیرات</TitleDescription>
      {isEditable && (
        <Button
          fullWidth
          mt={24}
          variant="outlined"
          color="success"
          onClick={() => setOpenModal(true)}
        >
          <Box mx={12}>
            <AddSvg stroke={token('colors.green-2')} width={20} height={20} />
          </Box>
          افزودن نوع تعمیر
        </Button>
      )}
      <WagesList isEditable={isEditable} />
    </Box>
  );
};
